import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'timeMillisToHoursMinutesAndSeconds'
})
export class TimeMillisToHoursMinutesAndSecondsPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    return null;
  }

}
